<template>
  <div class="asset-detail-page">
    <!-- banner & search -->
    <div class="banner">
      <!-- slogan -->
      <div class="slogan">
        <h1>让您的资产更具生命力</h1>
        <h3>庆源绿色金融，您的资产管家</h3>
        <el-button round class="go-assets" @click="goAssets"
          >更多资产</el-button
        >
      </div>
    </div>
    <!-- list -->
    <div class="asset-wrapper w-1200">
      <!-- Detail -->
      <div class="plus-header-wrapper information">
        <div class="plus-header">
          <div class="title">
            <h2>{{ assetDetail.title }}</h2>
            <p class="date">{{ assetDetail.createdate }}</p>
          </div>
          <!-- 金额暂时不展示 -->
          <!--<p class="values">￥<span class="highlight-text">1274万</span></p>-->
        </div>
        <div class="plus-body">
          <!-- 发布信息 -->
          <h4 class="info-title">发布信息</h4>
          <ul class="info-text publish-preview-content">
            <li v-for="(item, i) in assetDetail.baseContent" :key="i">
              {{ item }}
            </li>
          </ul>
          <p class="info-text" v-if="hasCollateral">
            发布内容：{{ assetDetail.extraContent }}
          </p>
          <!-- 担保物 -->
          <h4 class="info-title">
            担保物（{{ collateral.length }}）
          </h4>
          <ul>
            <li
              v-for="(item, index) in collateral"
              :key="index"
              style="display: flex"
            >
              <collateral :data="item" :index="index" :show-message="showCollateralMessage" />
            </li>
          </ul>
        </div>
      </div>
      <!-- Form -->
      <div class="plus-header-wrapper apply-form">
        <div class="plus-header">意 愿！</div>
        <div class="plus-body">
          <el-form ref="apply" :model="form" :rules="rules" label-width="120">
            <el-form-item label="联系人" prop="name" :error="errors.name">
              <el-input v-model="form.name" clearable></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email" :error="errors.email">
              <el-input v-model="form.email" clearable></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="content" :error="errors.content">
              <el-input
                v-model="form.content"
                type="textarea"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号码"
              prop="mobile"
              class="telephone-wrapper"
            >
              <el-input v-model="form.mobile" clearable></el-input>
              <el-button
                type="text"
                class="code-button"
                :loading="verifyCodeLoading"
                @click="getVerifyCode"
                >发送验证码</el-button
              >
            </el-form-item>
            <el-form-item label="验证码" prop="v_code" :error="errors.v_code">
              <el-input v-model="form.v_code" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                class="submit-button"
                @click="submit"
                :loading="formLoading"
                >我有意向</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateMobile, validateEmail } from "@/libs/formValidate";
import Collateral from "@/views/Template/collateral";
import OSSPreviewImg from "@/components/OSSPreviewImg";

export default {
  name: "assets",
  components: {
    collateral: Collateral,
    "preview-img": OSSPreviewImg
  },
  data() {
    return {
      // 订单
      assetDetail: {},
      // 担保物
      collateral: {},
      hasCollateral: false,
      form: {
        // name: "张茜茜",
        // email: "192@qq.com",
        // content: "测试内容",
        // mobile: "15223284591",
        // v_code: "1234",
        name: "",
        email: "",
        content: "",
        mobile: "",
        v_code: "",
        v_key: ""
      },
      rules: {
        name: [{ required: true, message: "请输入联系人" }],
        email: [
          {
            required: true,
            validator: validateEmail,
            message: "请输入电子邮箱"
          }
        ],
        content: [{ required: true, message: "请输入内容" }],
        mobile: [
          {
            required: true,
            validator: validateMobile,
            message: "请输入正确的手机号"
          }
        ],
        v_code: [{ required: true, message: "请输入验证码" }]
      },
      errors: {
        name: "",
        email: "",
        content: "",
        mobile: "",
        v_code: ""
      },
      formLoading: false,
      verifyCodeLoading: false
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    original_type() {
      return this.$route.query.original_type;
    },
    // 担保物描述是否展示文字信息，债权：展示 | 物权：不展示
    showCollateralMessage() {
      const type = Number(this.original_type);
      return type === 0 || type === 1;
    }
  },
  methods: {
    // 返回列表页
    goAssets() {
      this.$router.push({ name: "assets" });
    },

    // 获取详情
    async getDetail() {
      const param = { id: this.id };
      this.$request.assets_getAssetsDetail(param).then(async res => {
        if (res.code !== 0) {
          this.$message.error(res.msg);
          return;
        }

        const { asset_order = {}, pledge_mortgage = [] } = res.detail || {};

        // 订单信息
        this.assetDetail = this.uploadOrderData(asset_order || {}, pledge_mortgage || []);

        // 担保物信息
        this.collateral = await this.$viewModel.router.collateral_getCollaterals(
          pledge_mortgage || []
        );
      });
    },

    // 装载订单信息
    uploadOrderData(data, pledge_mortgage) {
      let { abstract, content, createdate, order_status, title } = data;

      /**
       * 解析规则
       * 1. 基础信息，如：债权信息、债权总额、债权本金、债权利息
       * 2. 担保物信息：担保物以“担保物”字段标识，每组担保物包含：[担保物n、所在地区、担保方式、担保物类型、担保物情况]
       * 示例："债权信息||债权总额：暂无||债权本金：暂无||债权利息：暂无||担保物1||所在地区：内蒙古自治区鄂尔多斯市达拉特旗||担保方式：暂无||担保物类型：综合||担保物情况：位置：鄂尔多斯市达拉特旗树镇达拉特路西树西街北育才B区综合楼5-6层\n面积：5层2118.86㎡ 6层1164.78㎡||||contentcontent"
       */

      let contentArr = content.split("||");

      // 只筛选债权信息相关的，其余多余信息（担保物、发布内容）不使用
      let baseContent = [];
      for (let i = 0; i < contentArr.length; i++) {
        let item = contentArr[i];
        // 出现“担保物”字段，说明后续都是担保物相关的数据了，除了最后一项是发布内容字段
        if (item.includes("担保物")) {
          this.hasCollateral = true;
          break;
        }
        baseContent.push(item);
      }

      // 发布内容
      let extraContent = contentArr[contentArr.length - 1];

      return {
        title,
        order_status,
        createdate,
        abstract,
        baseContent,
        extraContent
      };
    },

    // 获取手机验证码
    async getVerifyCode() {
      // console.log()
      this.$refs.apply.validateField("mobile", errMsg => {
        if (errMsg) return;
        const phoneNum = this.form.mobile;
        this.verifyCodeLoading = true;
        this.$request
          .assets_getVerifyCode({ phoneNum })
          .then(res => {
            this.verifyCodeLoading = false;
            if (res.code !== 0) {
              this.form.v_key = "";
              this.$message.error(res.msg);
              return;
            }
            this.form.v_key = res.key;
            this.$message.success("验证码成功发送，请用手机接收");
          })
          .catch(() => {
            this.form.v_key = "";
            this.verifyCodeLoading = false;
          });
      });
    },

    // 提交意向表单
    submit() {
      this.$refs.apply.validate(valid => {
        if (valid) {
          this.formLoading = true;
          let param = { asset_id: this.id, ...this.form };

          this.$request
            .assets_sendIntention(param)
            .then(res => {
              this.formLoading = false;
              if (res.code !== 0) {
                // 错误处理
                for (let key in res.msg) {
                  let transKey = key === "v_key" ? "v_code" : key;
                  let transVal = res.msg[key];
                  this.errors[transKey] = transVal;
                }
                return;
              }
              this.$message.success("提交成功");
              this.resetForm();
            })
            .catch(() => {
              this.formLoading = false;
            });
        }
      });
    },

    // 清空表单
    resetForm() {
      let form = {};
      for (let key in this.form) {
        form[key] = "";
      }
      this.form = form;
      this.$refs.apply.resetFields();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/pages/assets.scss";
</style>
